<template > 
    <div class="ordersContainer">
      <div class="loadingModal" v-if="isLoading">
            <div class="loader" ></div>
        </div>
        <!-- <div>
          <h3>التقرير اليومي للمبيعات</h3>
          <button @click="fetchSalesReport">عرض التقرير</button>
          
          <ul v-if="Object.keys(salesReport).length > 0">
            <li v-for="(count, product) in salesReport" :key="product">
              {{ product }}: {{ count }} مبيعات
            </li>
          </ul>

          <p v-else>لا توجد بيانات مبيعات لهذا اليوم.</p>
        </div> -->
        <div class="pageHeader">
          <div class="pageTitle">
            <span class="pageTitleText">דף ההזמנות <span class="total-orders">{{ this.acceptedOrders }}</span></span>
            <b @click="loadOrdersRealTime()" style="position: absolute;right: 15rem;font-size: 14px;"> <i class="material-icons">refresh</i> רענן הזמנות </b>
            <!-- <span class="pageOrdersCounterText" > סך הכל הזמנות: {{ this.acceptedOrders }}</span> -->
            <div class="topLine">
            <ul>
              <li :class="[yesterdayItemNav == true ? 'activeItem' : '']"><a href="#" @click="yesterdayOrders()">אתמול</a></li>
              <li :class="[todayItemNav == true ? 'activeItem' : '']"><a href="#" @click="todayOrders()">היום</a></li>
              <li :class="[tommorowItemNav == true ? 'activeItem' : '']"><a href="#" @click="tommorowOrders()">מחר</a></li>
            </ul>
          </div>
          </div>
          <!-- <div class="ordersStatics" v-show="this.$root.loggedUser.Type == 'Admin'">
            <div class="staticsBox">
              <span class="staticsTitle">
                סך הכל הזמנות
              </span>
              <span class="staticsData">
                {{ this.acceptedOrders }}
              </span>
            </div>
            <div class="staticsBox">
              <span class="staticsTitle">
                הזמנות מהיום להיום
              </span>
              <span class="staticsData">
                {{ this.fromToday }}
              </span>
            </div>
            <div class="staticsBox">
              <span class="staticsTitle">
                הזמנות שבוטלו
              </span>
              <span class="staticsData">
                {{ this.deletedOrders }}
              </span>
            </div>
            <div class="staticsBox">
              <span class="staticsTitle">
                סך הכל הזמנות
              </span>
              <span class="staticsData">
                {{ this.acceptedOrders }}
              </span>
            </div>
            <div class="staticsBox">
              <span class="staticsTitle">
                סך הכל הזמנות
              </span>
              <span class="staticsData">
                {{ this.acceptedOrders }}
              </span>
            </div>
          </div> -->
          
          <div class="searchData">
            <div class="searchBox">
              <!-- <label>חיפוש לפי שם או מספר טלפון</label> -->
              <i class="material-icons">search</i>
              <input type="text" placeholder="חיפוש לפי שם או מספר טלפון" v-model="txtSearch">
            </div>
            <div class="datesBox">
              <div class="filterByDate">
                
                <div class="dateField">
                  <input type="date" v-model="fromDate" @change="loadOrdersRealTime()">
                </div>
                <span>עד</span>
                <div class="dateField">
                  <input type="date" v-model="toDate" @change="loadOrdersRealTime()">
                </div>
              </div>

            </div>
          </div>
        </div>
      <!-- <div class="filter">
          <div class="totalOrdersContainer">
            <p class="font-noto totalOrderstext" style="font-weight: 600;">
                          סך הכל הזמנות
            </p>
            <span class="totalOrderbadge">{{ totalOrders }}</span>
          </div>
          <div class="filterByDate">
            <div class="dateField">
              <input type="date" v-model="fromDate" @change="loadOrders()">
            </div>
            <span>עד</span>
            <div class="dateField">
              <input type="date" v-model="toDate" @change="loadOrders()">
            </div>
          </div>
      </div> -->

        <div class="table">
          <div class="filterMobile">
            <h3>סינון הזמנות לפי תאריכים</h3>
              <div class="dateFieldMobile">
              <input type="date" v-model="fromDate" @change="loadOrdersRealTime()">
              
            </div>
            <span>עד</span>
            <div class="dateFieldMobile">
              <input type="date" v-model="toDate" @change="loadOrdersRealTime()">
            </div>
          </div>
          
            

          <orderCard   v-for="(order,index) in filteredOrders" :key="index" :id="order.ID" :order="order" :orderIndex="index"  v-if="order.Data.status !== 'נמחקה' "></orderCard>
          <div v-if="this.orders.length == 0" style="display: flex;flex-wrap: wrap;justify-content: center;align-items: center;flex-direction: column;" >
            <img src="../../static/img/nodata.png" width="500px" />
            <b style="font-size: 18px;"> אין כרגע הזמנות</b>
          </div>
        </div>
            <!-- زر ثابت في أسفل الشاشة -->
    <button class="fixed-report-btn" @click="showModal = true">
      📊 عرض التقرير
    </button>
        <!-- المودال -->
        <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <button class="close-btn" @click="showModal = false">✖</button>
        <h3>📈 تقرير المبيعات</h3>

        <!-- حقل اختيار التاريخ -->
        <label>📅 اختر تاريخ:</label>
        <input type="date" v-model="selectedDate" @change="fetchSalesReport" class="datePicker">

        <button @click="fetchSalesReport" class="refresh-btn">🔄 تحديث التقرير</button>

        <div v-if="Object.keys(salesReport).length > 0" class="sales-list">
          <div v-for="(count, product) in salesReport" :key="product" class="sales-item">
            <span class="product-count">{{ count }} </span>
            <span class="product-name">{{ product }}</span>
          </div>
        </div>

        <p v-else>لا توجد مبيعات في هذا اليوم.</p>
      </div>
    </div>
        <!-- <order v-for="(order,index) in orders" :key="order.ID" :id="order.ID" :order="order" :orderIndex="index"> </order> -->
    </div>
</template>
<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import he from 'moment/locale/he'
import order from '../components/Order.vue';
import orderCard from '../components/orderCard.vue';
export default {
  name: 'Orders',
  components:{
    order,orderCard
  },
  data () {
    return {
      orders:[],
      txtSearch:'',
      toDate: '',
      fromDate: '',
      totalOrders:0,
      deletedOrders:0,
      acceptedOrders:0,
      fromToday:0,
      yesterdayItemNav:false,
      todayItemNav:false,
      tommorowItemNav:false,
      isLoading:true,
      salesReport: {}, // تخزين إجمالي المنتجات المباعة هنا 
      showModal: false, // يتحكم في عرض المودال
      selectedDate: new Date().toISOString().split("T")[0], // افتراضيًا اليوم الحالي


    }
  },
  watch: {
  selectedDate(newDate) {
    console.log("📅 تم تغيير التاريخ إلى:", newDate);
    this.fetchSalesReport();
  }
},

  created (){
    const m = moment();
    m.locale('he');
    console.log(m.format('LLLL'));
    let vm = this ;
    vm.fromDate = moment().format("YYYY-MM-DD");
    vm.toDate = moment().add(10, 'days').format("YYYY-MM-DD");
    vm.todayItemNav = true;
    vm.loadOrdersRealTime();
    if(vm.totalOrders == 0){
      vm.totalOrders = 0 ;
    }

  },
  computed: {
      filteredOrders() {
        let vm = this;
        if (vm.txtSearch.length > 0) {
          let orders = [];
          for (let i = 0; i < vm.orders.length; i++) {
            let t = vm.orders[i];
            let found = false;
            if (t.Data.fullname.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              found = true;
            }
            if (t.Data.phoneNumber.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              found = true;
            }
            // if (t.Time.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
            //   found = true;
            // }
            if (found) {
              orders.push(t);
            }
          }
          return orders;
        } else {
          return vm.orders;
        }
      }
    },
    mounted() {
    this.fetchSalesReport(); // تحديث التقرير عند تحميل الصفحة بناءً على التاريخ الافتراضي
  },
  methods: {
    async fetchSalesReport() {
  console.log("🚀 جلب البيانات لتاريخ:", this.selectedDate);
  
  if (!this.selectedDate) return;

  const ordersRef = firebase.firestore().collection("orders");

  try {
    const snapshot = await ordersRef.where("dateOrder", "==", this.selectedDate).get();

    if (snapshot.empty) {
      console.warn("⚠️ لا توجد طلبات لهذا اليوم.");
      this.salesReport = {};
      return;
    }

    let salesData = {};

    snapshot.forEach(doc => {
      const order = doc.data();
      if (!order.cart || !Array.isArray(order.cart)) return;

      order.cart.forEach(product => {
        const productName = (product.Data && product.Data.Name) ? product.Data.Name : "منتج غير معروف";
        const quantity = product.selectedCount ? Number(product.selectedCount) : 0;

        if (!salesData[productName]) {
          salesData[productName] = 0;
        }
        salesData[productName] += quantity;
      });
    });

    this.salesReport = salesData;
    console.log("✅ البيانات المحدثة:", this.salesReport);

  } catch (error) {
    console.error("❌ حدث خطأ أثناء جلب البيانات:", error);
  }
}
,

      todayOrders(){
        let vm = this;
        vm.todayItemNav = true;
        vm.tommorowItemNav = false;
        vm.yesterdayItemNav = false;

        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().format("YYYY-MM-DD");
        vm.toDate = moment().format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      tommorowOrders(){
        let vm = this;
        vm.tommorowItemNav = true;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().add(1, 'days').format("YYYY-MM-DD");
        vm.toDate = moment().add(1, 'days').format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      thisMonth(){
        let vm = this;
        vm.tommorowItemNav = false;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().startOf('month').format("YYYY-MM-DD");
        vm.toDate = moment().endOf('month').format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      lastMonth(){
        let vm = this;
        vm.tommorowItemNav = false;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().subtract("1","months").startOf('month').format("YYYY-MM-DD");
        vm.toDate = moment().subtract("1","months").endOf('month').format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      yesterdayOrders(){
        let vm = this;
        vm.yesterdayItemNav = true;
        vm.todayItemNav = false;
        vm.tommorowItemNav = false;
        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        vm.toDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      loadOrders(){
          let vm = this;
          vm.orders = [];
          vm.totalOrders = 0 ;
          vm.deletedOrders = 0;
          vm.acceptedOrders = 0;
          vm.deletedOrders = 0;
          //  .orderBy("orderNumber","desc")
          // .where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate)
          db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).orderBy("dateOrder","asc").get()
          .then(function(orderResult){
              for(let a = 0; a < orderResult.size; a++){
                  let orderId = orderResult.docs[a].id;
                  let order = orderResult.docs[a].data();
                  // console.log(orderResult.size);
                  vm.orders.push({ ID: orderId, Data: order });   
                  vm.totalOrders = orderResult.size;

                  if (order.status == 'נמחקה') {
                    vm.deletedOrders++;
                  }

              }

              if( vm.deletedOrders == 0){
                vm.acceptedOrders = vm.totalOrders;
              }
              // db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).where('status', '==', 'נמחקה').get()
              // .then(function(deletedResult){
              //   for(let a = 0; a < deletedResult.size; a++){
              //     // console.log(vm.deletedOrders);
              //     // console.log(deletedResult.docs[a].id);
              //     vm.deletedOrders = deletedResult.size;
              //   } 
              //   if(vm.totalOrders - vm.deletedOrders <= 0){
              //     vm.acceptedOrders = vm.totalOrders;
              //   }
              //   if( vm.deletedOrders == 0){
              //       // vm.deletedOrders = 0;
              //       vm.acceptedOrders = vm.totalOrders;

              //     }
              //     else {
              //       vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
              //     }
              // }).catch(function(error){
              //     console.error("Error getting document:", error);
              //     });
          })

          .catch(function(error){
              console.error("Error getting document:", error);
      });
      },
      // loadOrdersRealTime(){
      //     let vm = this;
      //     vm.fromToday = 0;
      //     vm.totalOrders = 0 ;
      //     vm.deletedOrders = 0;
      //     vm.acceptedOrders = 0;
          
      //     //  .orderBy("orderNumber","desc")
      //     // .where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate)
      //     db.collection("orders").where('dateOrder', '>=', vm.fromDate)
      //     .where('dateOrder', '<=', vm.toDate).orderBy("dateOrder","asc").orderBy("timeOrder","asc").onSnapshot((orderResult) => {
      //       vm.isLoading = false;
      //       vm.orders = [];
      //       vm.totalOrders = orderResult.size;
      //         orderResult.forEach((doc) => {
      //                 let orderId = doc.id;
      //                 let order = doc.data();
      //                 // vm.totalOrders = doc.size;
      //                 vm.orders.push({ ID: orderId, Data: order });   
      //                 if(order.Date == order.dateOrder){
      //                 vm.fromToday++;
      //                 }
      //                 if(order.status == 'נמחקה'){
      //                   vm.deletedOrders++;
      //                 }
      //                 if( vm.deletedOrders == 0){
      //                   vm.acceptedOrders = vm.totalOrders;
      //                 }


      //               });
                    
      //         // db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).where('status', '==', 'נמחקה').get()
      //         // .then(function(deletedResult){
      //         //   for(let a = 0; a < deletedResult.size; a++){
      //         //     // console.log(vm.deletedOrders);
      //         //     // console.log(deletedResult.docs[a].id);
      //         //     vm.deletedOrders = deletedResult.size;
      //         // } 

      //         // if(vm.totalOrders - vm.deletedOrders <= 0){
      //         //   vm.acceptedOrders = vm.totalOrders;
      //         //     }
      //         //     if( vm.deletedOrders == 0){
      //         //       // vm.deletedOrders = 0;
      //         //       vm.acceptedOrders = vm.totalOrders;

      //         //     }
      //         //     else {
      //         //       vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
      //         //     }
      //         //     // console.log('deleted Orders :',vm.deletedOrders);
      //         //     // console.log('accepted Orders :',vm.acceptedOrders);

      //         //  })
      //         //  .catch(function(error){
      //         //     console.error("Error getting document:", error);
      //         //     });
                

      //           })
      //         },
   loadOrdersRealTime() {
  let vm = this;
  vm.fromToday = 0;
  vm.totalOrders = 0;
  vm.deletedOrders = 0;
  vm.acceptedOrders = 0;
  vm.orders = [];
  vm.isLoading = true;

  const ordersRef = db.collection("orders");

  // استعلام الطلبات حسب dateOrder
  const query1 = ordersRef
    .where("dateOrder", ">=", vm.fromDate)
    .where("dateOrder", "<=", vm.toDate);

  // استعلام الطلبات حسب dayOrder
  const query2 = ordersRef
    .where("dayOrder", ">=", vm.fromDate)
    .where("dayOrder", "<=", vm.toDate);

  // نفّذ الاستعلامين
  Promise.all([query1.get(), query2.get()])
    .then(([snapshot1, snapshot2]) => {
      let allDocs = [];

      snapshot1.forEach((doc) => {
        allDocs.push({ ID: doc.id, Data: doc.data() });
      });

      snapshot2.forEach((doc) => {
        // تأكد ما تكرّر الطلب إذا موجود بالاستعلام الأول
        if (!allDocs.find((o) => o.ID === doc.id)) {
          allDocs.push({ ID: doc.id, Data: doc.data() });
        }
      });

      vm.totalOrders = allDocs.length;

allDocs.sort((a, b) => {
  const dateA =
    a.Data.selectedDateReadable || a.Data.dayOrder || a.Data.dateOrder || '';
  const dateB =
    b.Data.selectedDateReadable || b.Data.dayOrder || b.Data.dateOrder || '';

  const timeA = a.Data.timeOrder ? a.Data.timeOrder.padStart(5, '0') : '00:00';
  const timeB = b.Data.timeOrder ? b.Data.timeOrder.padStart(5, '0') : '00:00';

  const datetimeA = `${dateA} ${timeA}`;
  const datetimeB = `${dateB} ${timeB}`;

  return datetimeA.localeCompare(datetimeB);
});



      vm.orders = allDocs;

      allDocs.forEach((order) => {
       const orderDate =
  order.Data.selectedDateReadable ||
  order.Data.dayOrder ||
  order.Data.dateOrder;

if (orderDate === vm.fromDate) vm.fromToday++;

        if (order.Data.status === "נמחקה") vm.deletedOrders++;
      });

      if (vm.deletedOrders === 0) {
        vm.acceptedOrders = vm.totalOrders;
      } else {
        vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
      }

      vm.isLoading = false;
    })
    .catch((error) => {
      console.error("❌ خطأ في تحميل الطلبات:", error);
      vm.isLoading = false;
    });
}


      }
    }

</script>

<style scoped>
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans Hebrew';

}
.material-icons{
  font-family: 'Material Icons';
}
.font-noto{
    font-family: 'Noto Sans Hebrew';
}
.loadingModal{
    width: 100%;
    height: 100%;

    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    z-index: 11111;
    position: fixed;
    right: 0;
    top: 0;
    background-color: rgba(0,0,0,0.2);
}
.loader{
    margin:  auto;
    border: 10px solid #EAF0F6;
    border-radius: 50%;
    border-top: 10px solid #00414d;
    width: 100px;
    height: 100px;
    animation: spinner 1s linear infinite;
    z-index: 100000;
}
@keyframes spinner {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
.pageHeader{
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.ordersStatics{
  width: 100%;
  border-radius: 5px;
  /* border: 1px solid #e0e0e0; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.staticsBox{
  width: calc(100% / 5 - 5px);
  min-height: 120px;
  border-radius: 5px;
  background-color:#e0eefd ;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid#5A606324 ;
}
.staticsBox .staticsTitle ,
.staticsBox  .staticsData{
  font-size: 13px;
  font-weight: 600;
  font-family: 'Noto Sans Hebrew';
  color: #6c6d89;
  display: block;
}
.staticsBox  .staticsData{
  font-size: 28px;
  font-weight: 900;
  color: #030408;
}
.pageTitle{
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.pageTitle .pageTitleText ,
.pageTitle .pageOrdersCounterText{
  color: #141c29;
  font-family: 'Noto Sans Hebrew';
}
.pageTitle .pageTitleText{
  font-size: 24px;
  font-weight: bold;
}
.total-orders{
  font-size: 16px;
  padding: 5px 15px;
  border: 1px solid #dadada;
  border-radius: 5px;
}
.pageTitle .pageOrdersCounterText{
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  left: 0rem;
}
.topLine{
  border: 1px solid #f4f5f8;
  border-radius: 5px;
  width: 220px;
  display: flex;
  align-items: center;
  height: 40px;
  overflow: hidden;
}
.topLine ul{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 5px 0;
  margin: 0;
  position: relative;
}
.topLine ul li{
  list-style: none;
  /* display: inline-block; */
  padding: 0 15px;
  cursor: pointer;
}
.topLine ul li a{
  text-decoration: none;
  font-size: 14px;
  color: #141c29;
}
.activeItem{
  background-color: #f4f5f8;
  color: #141c29;
  list-style: none;
  display: inline-block;
  padding: 0 10px;
  border-radius: 5px;
  line-height: 2;
}
.getOrders{
  display: flex;
  align-items: center;
  color: #141c29;
  position: absolute;
  left: 0;
  font-size: 14px;
  background-color: #f4f5f8;
  line-height: 40px;

}
.getOrders i{
  font-size: 18px;
  margin-left: 5px;
}
.searchData{
  width: 100%;
  padding: 1rem;
  background-color: #f4f5f8;
  border-radius: 8px;
  display: flex;
  margin-bottom: 10px;
}
.searchBox{
  width: 50%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
}
.datesBox{
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.searchBox i{
  position: absolute;
    right: 10px;
    font-size: 20px;
    line-height: 40px;
    color: #B4B9C7;
}
.searchBox input[type=text]{
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid #B4B9C7;
  background-color: #fff;
  height: 40px;
  color: #141c29;
  font-size: 14px;
  padding-right: 40px;
  font-family: 'Noto Sans Hebrew';
  line-height: 40px;

}
.filterByDate{
  border-radius: 2px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #B4B9C7;
  background-color: #fff;
  font-family: 'Noto Sans Hebrew';

}
.totalOrderstext{
  margin-bottom: 0;
}
.icon{
    font-size: 16px;
    margin-left: 10px;
}
.ordersContainer{
  width: 100%;
  padding: 1rem;
  height: 100%;
}
.table{
    width: 100%;
    float: right;
    display: flex;
    align-items: stretch;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 600px;
    height: 100%;

}
.ordersTable{
  width: 75%;
  min-height: 200px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  float: right;
  height: 100%;

}
/* .filter{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
} */
.totalOrdersContainer{
  width: 30%;
  padding: 0rem;
  border:0;
  border-radius: 10px;
  overflow: hidden;
  float: left;
  position: relative;
  display: flex;
  align-items: center;
}
.totalOrderbadge{
  position: absolute;
    left: 1rem;
    background: antiquewhite;
    padding: 3px 20px;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 600;
}
.ordersTitle{
  width: 100%;
  padding: 1rem;
  background-color: #fcfcfc;
  display: flex;
  align-items: center;
  position: relative;
}
.ordersTitle span{
  font-size: 20px;
  color: #666;
  font-weight: 500;
}
.ordersTitle .boxTitle{
  font-size: 18px;
  color: #666;
  font-weight: 500;
  margin: 0 10px;
}
.inputBox{
  position: absolute;
  left:1rem
}
.inputBox input{
  width: 400px;
  height: 35px;
  padding-right: 10px;
  font-size: 14px;
  border: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 5px;
}
.filterHeader{
  border-bottom:1px solid #f5f5f5;
  display: flex;
  align-items: center;
  padding: 1rem 1rem  0 0;
  background-color: aliceblue;
}
.dateField{
  padding: 0;
}
.dateField label{
  display:block;
  font-size: 14px;
  color: #666;
}
.dateField input{
  width: 100%;
  height: 40px;
  border-radius: 8px;
  padding: 0 10px;
  color: #666;
  border: none;
  font-size: 13px;
  outline: none;
  -webkit-appearance:none;
}
.filterMobile{
  display: none;
}
/* زر ثابت أسفل الشاشة */
.fixed-report-btn {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #007bff;
  color: white;
  padding: 12px 20px;
  font-size: 16px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
}
.fixed-report-btn:hover {
  background-color: #0056b3;
}

/* تصميم المودال */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  min-height: 500px;
  max-height: 700px; /* تحديد الحد الأقصى للارتفاع */
  overflow-y: auto; /* تمكين التمرير العمودي عند الحاجة */
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
}

/* زر إغلاق المودال */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

/* تصميم قائمة المبيعات */
.sales-list {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* تصميم كل منتج */
.sales-item {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}
.sales-item:hover {
  transform: scale(1.03);
}

/* تنسيق النص */
.product-name {
  font-weight: 500;
  color: #333;
  margin-right: 1rem;
}
.product-count {
  background-color: #1c1c1c;
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}
/* تحسين تصميم input لاختيار التاريخ */
.datePicker {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s ease-in-out;
}

.datePicker:focus {
  border-color: #0056b3;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* تحسين تصميم زر التحديث */
.refresh-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.3s ease-in-out;
}

.refresh-btn:hover {
  background-color: #218838;
}

@media screen and (max-width:500px){
  .totalOrdersContainer,
  .filterByDate{
    display: none;
  }
  .table{
    width: 100%;
  }
  .filterMobile{
    background-color: #fff;
    width: 100%;
    padding: 1rem;
    float: right;
    display: block;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 120px;
  }
  .dateFieldMobile input{
    border: 0;
    background-color: transparent;
    background-color: #f5f5f5;
    border-radius: 8px;
    -webkit-appearance:none;
  }
  .filterMobile h3{
    font-size: 16px;
    color: #666;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
    display: block;
    width: 100%;
  }
  .filterMobile span{
    font-size: 16px;
  }
  .searchBox{
    width: 100%;
  }
  .datesBox{
    display: none;
  }
  .loadingModal{
    margin-right: -10px;
  }
  .fixed-report-btn {
    padding: 8px 15px;
    font-size: 14px;
    bottom: 90px;
    left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Orders.vue